import React from "react";
const DEFAULT_TEXT = `No Results!`;
export function NoRelatedResults({ text = DEFAULT_TEXT, isLoading }) {
  return (
    <div className="chronos-article-picker-result-item chronos-no-results">
      {isLoading && <h3>Loading...</h3>}
      {!isLoading && <h3>{text}</h3>}
    </div>
  );
}
